import { Button, Flex } from "@chakra-ui/react";
import { StatusEncerradoBucket } from "@/models/consignado/proposal-billings.model";
import { STATUS_ENCERRADO_LABEL, StatusFiltroEncerrado } from "./statusEncerrado";

const OPCOES: { value: StatusFiltroEncerrado; label: string }[] = [
  { value: "TODOS", label: "Todos" },
  ...(Object.entries(STATUS_ENCERRADO_LABEL) as [StatusEncerradoBucket, string][]).map(
    ([value, label]) => ({ value, label })
  ),
];

type Props = {
  statusFiltro: StatusFiltroEncerrado;
  setStatusFiltro: (status: StatusFiltroEncerrado) => void;
};

export default function StatusFilterBarEncerrados({ statusFiltro, setStatusFiltro }: Props) {
  return (
    <Flex gap={4} flexWrap="wrap">
      {OPCOES.map((opcao) => (
        <Button
          key={opcao.value}
          size="lg"
          colorScheme="primary"
          variant={statusFiltro === opcao.value ? "solid" : "outline"}
          bg={statusFiltro === opcao.value ? undefined : "white"}
          onClick={() => setStatusFiltro(opcao.value)}
        >
          {opcao.label}
        </Button>
      ))}
    </Flex>
  );
}
